import { createReducer, on } from '@ngrx/store';
import { CgeNews, News } from '@qvs/core';
import * as fromNewsActions from './news.actions';

export const newsFeatureKey = 'news';

export interface State {
  news: News;
  newsIsLoading: boolean;
  newsHasErrors: boolean;
  readNewsIds: number[];
  cgeNews: CgeNews;
  cgeNewsIsLoading: boolean;
  cgeNewsHasErrors: boolean;
  hasMoreCgeNewsPages: boolean;
  currentCgeNewsPage: number;
}

export const initialState: State = {
  news: {
    items: []
  },
  newsIsLoading: true,
  newsHasErrors: false,
  readNewsIds: [],
  cgeNews: {
    items: [],
    totalItems: 0
  },
  cgeNewsIsLoading: true,
  cgeNewsHasErrors: false,
  hasMoreCgeNewsPages: false,
  currentCgeNewsPage: 0
};

export const reducer = createReducer(
  initialState,
  on(fromNewsActions.loadNews, (state) => ({
    ...state,
    newsIsLoading: true
  })),
  on(fromNewsActions.loadNewsFailure, (state) => ({
    ...state,
    newsIsLoading: false,
    newsHasErrors: true
  })),
  on(fromNewsActions.loadNewsSuccess, (state, { items }) => ({
    ...state,
    newsIsLoading: false,
    newsHasErrors: false,
    news: {
      ...state.news,
      items: [...items]
    }
  })),
  on(fromNewsActions.markNewsAsRead, (state, { newsId }) => {
    const newReadNewsIds = state.readNewsIds?.includes(newsId) ? state.readNewsIds : [...(state.readNewsIds || []), newsId];
    return {
      ...state,
      readNewsIds: newReadNewsIds
    };
  }),
  on(fromNewsActions.loadCgeNews, (state) => ({
    ...state,
    cgeNewsIsLoading: true,
    cgeNewsHasErrors: false
  })),
  on(fromNewsActions.loadCgeNewsFailure, (state) => ({
    ...state,
    cgeNewsIsLoading: false,
    cgeNewsHasErrors: true
  })),
  on(fromNewsActions.loadCgeNewsSuccess, (state, { newCgeNewsItems, totalItems, hasMoreCgeNewsPages }) => ({
    ...state,
    cgeNewsIsLoading: false,
    cgeNewsHasErrors: false,
    cgeNews: {
      ...state.cgeNews,
      items: [...state.cgeNews.items, ...newCgeNewsItems],
      totalItems
    },
    hasMoreCgeNewsPages
  })),
  on(fromNewsActions.resetCgeNews, (state) => ({
    ...state,
    cgeNewsIsLoading: false,
    cgeNewsHasErrors: false,
    cgeNews: {
      ...state.cgeNews,
      items: [],
      totalItems: 0
    },
    hasMoreCgeNewsPages: false,
    currentCgeNewsPage: 0
  })),
  on(fromNewsActions.setCurrentCgeNewsPage, (state, { page }) => ({
    ...state,
    currentCgeNewsPage: page
  }))
);
